import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextPersonalInfoComponent } from './text-personal-info.component';

@NgModule({
  declarations: [TextPersonalInfoComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
  ],
  exports:[TextPersonalInfoComponent],
})
export class TextPersonalInfoModule { }
